import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Feed from './Feed';
import NotFound from './NotFound';

const Routes = props => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="/genres/all" />} />
    <Route exact path="/genres" render={() => <Redirect to="/genres/all" />} />
    <Route
      exact
      path="/stations"
      render={() => <Redirect to="/stations/all" />}
    />
    <Route
      path="/:pageType/:filterName"
      render={subProps => <Feed {...props} {...subProps} />}
    />
    <Route path="*" render={() => <NotFound terms={props.terms} />} />
  </Switch>
);
export default Routes;
